import { useState, useEffect } from "react";
import { api } from "@/App";
import { Flame, Coins } from "lucide-react";

export default function StreakMeter() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/streak/mine").then((res) => setData(res.data)).catch(() => {});
  }, []);

  if (!data) return null;
  const { current_streak, needed, rewards_earned } = data;
  const remaining = needed - current_streak;

  return (
    <div className="mb-8 p-5 rounded-2xl bg-orange-500/5 border border-orange-500/20" data-testid="streak-meter">
      <div className="flex items-center justify-between mb-3">
        <p className="font-semibold flex items-center gap-2">
          <Flame className="w-5 h-5 text-orange-400 fill-orange-400/30" /> Date Streak
        </p>
        {rewards_earned > 0 && (
          <span className="text-xs text-amber-400 flex items-center gap-1" data-testid="streak-rewards-earned">
            <Coins className="w-3.5 h-3.5" /> {rewards_earned} reward{rewards_earned > 1 ? "s" : ""} earned
          </span>
        )}
      </div>
      <div className="flex items-center gap-3 mb-3">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className={`flex-1 h-11 rounded-xl border flex items-center justify-center transition-colors ${
              i <= current_streak
                ? "bg-orange-500/20 border-orange-400/50"
                : "bg-white/[0.03] border-white/10"
            }`}
            data-testid={`streak-slot-${i}`}
          >
            <Flame
              className={`w-5 h-5 ${
                i <= current_streak ? "text-orange-400 fill-orange-400" : "text-white/15"
              }`}
            />
          </div>
        ))}
      </div>
      <p className="text-sm text-muted-foreground" data-testid="streak-message">
        {current_streak === 0 && "Earn 3 date reviews of 4★ or better in a row to unlock 150 FREE credits."}
        {current_streak > 0 && remaining > 0 && (
          <>
            <span className="text-orange-400 font-medium">{current_streak} of {needed}</span> great dates — {remaining} more 4★+ review{remaining > 1 ? "s" : ""} until <span className="text-amber-400 font-medium">150 FREE credits</span>!
          </>
        )}
        {remaining <= 0 && "Streak complete — your free credits are on the way! A new streak starts now."}
      </p>
    </div>
  );
}
